import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ArticleForm from '../../../components/forms/ArticleForm';
import { useArticleApi } from '../../../hooks/useArticleApi';
import { useNavigate } from 'react-router-dom';
import { ArticleDTO } from '../../../services/apiClient';

const ArticleCreate: React.FC = () => {
  const { create, isLoading } = useArticleApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Articles', href: '/admin/articles' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ArticleDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/articles');
    } catch (error) {
      console.error('Error creating Article:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/articles"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Content.Article.Edit'
    >
      <ArticleForm
        initialValues={{} as ArticleDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/articles')}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default ArticleCreate;